module.exports = __webpack_public_path__ + "0ccc62309e8cf65fbb1555bc5d38c627.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/system_comment.svg
// module id = gkci
// module chunks = 1